import { Button, ButtonProps, styled } from '@mui/material'
import React from 'react'
import { ArrowRight } from './ArrowRight'

const ButtonWithStyles = styled(Button)`
  padding: 0;
  .MuiButton-endIcon {
    opacity: 0;
    transition:
      opacity 200ms ease,
      transform 200ms ease;
    transform: translateX(-8px);
  }

  &:hover {
    .MuiButton-endIcon {
      opacity: 1;
      transform: translateX(0);
    }
  }
`

export const ArrowButton: React.FunctionComponent<ButtonProps> = (props) => {
  return <ButtonWithStyles {...props} variant="text" endIcon={<ArrowRight />} />
}
